import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { localizeRequirementLabel } from './requirement-label';

// Re-Export, damit bestehende Import-Pfade nicht brechen. Wahrheitsort ist
// jetzt shared/requirement-label.ts (fboudouhi Info I1 + I2).
export { REQUIREMENT_STATUS_I18N_KEYS } from './requirement-label';

@Pipe({ name: 'requirementStatusLabel', standalone: true, pure: false })
export class RequirementStatusLabelPipe implements PipeTransform, OnDestroy {
  private translate = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);
  private sub: Subscription;

  constructor() {
    this.sub = this.translate.onLangChange.subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  transform(value: string | null | undefined): string {
    return localizeRequirementLabel('status', value, this.translate);
  }
}
